import { ToggleButton, ToggleButtonGroup, Tooltip } from '@mui/material';
import TextDecreaseRoundedIcon from '@mui/icons-material/TextDecreaseRounded';
import TextFieldsRoundedIcon from '@mui/icons-material/TextFieldsRounded';
import TextIncreaseRoundedIcon from '@mui/icons-material/TextIncreaseRounded';
import { useTranslation } from 'react-i18next';
import { useFontScaleStore, type FontScale } from './fontScaleStore';

export function FontScaleSwitcher(): JSX.Element {
  const { t } = useTranslation();
  const { scale, setScale } = useFontScaleStore();

  const OPTIONS: { value: FontScale; label: string; icon: JSX.Element }[] = [
    {
      value: 'small',
      label: t('fontScale.small', { defaultValue: 'Mniejsza czcionka' }),
      icon: <TextDecreaseRoundedIcon fontSize="small" aria-hidden />,
    },
    {
      value: 'normal',
      label: t('fontScale.normal', { defaultValue: 'Normalna czcionka' }),
      icon: <TextFieldsRoundedIcon fontSize="small" aria-hidden />,
    },
    {
      value: 'large',
      label: t('fontScale.large', { defaultValue: 'Większa czcionka' }),
      icon: <TextIncreaseRoundedIcon fontSize="small" aria-hidden />,
    },
  ];

  return (
    <ToggleButtonGroup
      value={scale}
      exclusive
      size="small"
      onChange={(_e, next: FontScale | null) => {
        if (next) setScale(next);
      }}
      aria-label={t('fontScale.ariaLabel', { defaultValue: 'Rozmiar czcionki' })}
      sx={{
        '& .MuiToggleButton-root': {
          border: 0,
          px: 1,
          height: 32,
          minHeight: 32,
          borderRadius: 1,
          color: 'text.secondary',
          '&.Mui-selected': {
            backgroundColor: (t) => t.palette.action.selected,
            color: 'primary.main',
          },
          '&:not(:first-of-type)': { ml: 0.25 },
        },
      }}
    >
      {OPTIONS.map((opt) => (
        <ToggleButton key={opt.value} value={opt.value} aria-label={opt.label}>
          <Tooltip title={opt.label}>{opt.icon}</Tooltip>
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
